// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"711":"3e425969","763":"1cca0623","885":"4cea13cd"}[chunkId] + ".chunk.js";
};